import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Table,
} from '@alifd/next';
import {
  HomeOutlined,
  SettingFilled,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
} from '@ant-design/icons';

import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import SolutionLink from '../../../../layouts/BasicLayout/components/SolutionLink';
import HeaderAvatar from '../../../../layouts/BasicLayout/components/HeaderAvatar';
import Notice from '../../../../layouts/BasicLayout/components/Notice';
import $ from "jquery";

const Home = (props) => {
  const [dateTime, setDateTime] = useState(new Date());
  const chineseWeekDay = () =>{
    let day = '星期';
    switch (new Date().getDay()) {
      case 0:
        day = day+"天";
        break;
      case 1:
        day = day+"一";
        break;
      case 2:
         day = day+"二";
        break;
      case 3:
        day = day+"三";
        break;
      case 4:
        day = day+"四";
        break;
      case 5:
        day = day+"五";
        break;
      case 6:
        day = day+"六";
    }
    return day;
  }
  const BasicDate = {
    imgTitle:"社區住戶條款",
    imgContent:"住戶於公寓大廈內依法經營餐飲、瓦斯、電焊或其他 危險營業或存放有爆炸性或易燃性物品者，應依中...",
    btns:()=>{
      return [...new Array(11)].map((i,nb)=>{
        return (
          <div key={nb} className={styles.flex}>
            <img src="/ezcon/ezcon_logo.png" alt=""/>
            <span className={styles.infoText}>NEW</span>
            <span className={styles.btn}>按鈕{nb}</span>            
          </div>
        );
      })      
    }
  }

  const setFlexHeight= ()=>{
    if($('#btnArea>div').length>0){
      const cw = $('#btnArea>div')[0].clientWidth;
      //console.log($('#btnArea>div')[0].clientWidth);
      $('#btnArea>div').css({'height':cw+'px'});
    }    
  }

  useEffect(() => {
    const id = setInterval(() => setDateTime(new Date()), 1000);

    setFlexHeight();
    $( window ).resize(function() {
      setFlexHeight();
    });    

    return () => {
      clearInterval(id);
    }
  }, []);

  return (
    <>
      <div className={styles.main}>

        <div className={styles.Topheader}>          
          <span>物業管理</span>
          <div className={styles.avatar1}>
            <HeaderAvatar />
          </div> 
          <div className={styles.avatar2}>
            <Notice />
          </div>           
        </div>

        <div className={styles.picArea}>
          <img src="/ezcon/ezcon_logo.png" alt=""/>
          <div className={styles.imgText}>
            <p className={styles.title}>{BasicDate.imgTitle}</p>
            <p className={styles.content}>{BasicDate.imgContent}</p>
          </div>

          <div className={styles.timeText}>

            <div className={styles.timeWord}>
              {moment(dateTime).format('YYYY-MM-DD')} {chineseWeekDay()}
              <span>
                {moment(dateTime).format('HH:mm')}
                <span>
                  {new Date().getHours()>=12?'PM':'AM'}
                </span>
              </span>
              <span className={styles.weatherIcon}></span>
            </div>
            

            <div className={styles.hotMessage}>
              <p>熱門訊息</p>
              <div className={styles.item}>
                <div className={styles.t1}>
                  <span>社區規約</span>
                </div>
                <div className={styles.t2}>
                  <span>社區住戶條款</span>
                  <span>2021-5-28</span>                
                </div>
                <div className={styles.t3}>
                住戶於公寓大廈內依法經營餐飲、瓦斯、電焊或其他危險...
                </div>
              </div>

              <div className={styles.item}>
                <div className={styles.t1}>
                  <span>社區規約</span>
                </div>
                <div className={styles.t2}>
                  <span>社區住戶條款</span>
                  <span>2021-5-28</span>                
                </div>
                <div className={styles.t3}>
                住戶於公寓大廈內依法經營餐飲、瓦斯、電焊或其他危險...
                </div>
              </div>

            </div>            

          </div>          

        </div>

        {/* <div className={styles.btnAreaFa}> </div>   */}
        <div id="btnArea" className={styles.btnArea}>
          {/* <div className={styles.flex}></div> */}
          {BasicDate.btns()}
        </div>
             
      </div>

    </>
  );
};

export default Home;

